module.exports = __webpack_public_path__ + "img/meitu.54638bf2.jpg";